import { all } from "redux-saga/effects"
import read from "./read"
import markOne from "./markOne"
import markAll from "./markAll"
import readWS from "./readWS"

export default function*() {
  while (true) {
    yield all({
      read: read(),
      markOne: markOne(),
      markAll: markAll(),
      readWS: readWS(),
    })
  }
}
